export const sgcTypes = {
    GET_SGC: 'GET_SGC',
    SGC_CLEAN_STATE: 'SGC_CLEAN_STATE'
}